module.exports = __webpack_public_path__ + "static/image2-9cdc3d4bf7e00ef65747f1fc63738f44.jpg";